import { ArrowBack } from '@mui/icons-material'
import { Box } from '@mui/material'
import React, { useState } from 'react'
import CourseDetailed from './courseDetailed'
import UniversityDetailed from './universityDetailed'

const MainPopup = (props:any) => {
    const [initialState,setInitialState] = useState<"course"|"university">("course")
  return (
    <div style={{padding:"1rem"}}>
        {
            initialState === "course"?
            <CourseDetailed data={{ 
              data: props.data._id, 
              setInitialState: setInitialState, 
              icon: false 
            }}  /> : 
            <Box >
                <ArrowBack onClick={()=>setInitialState("course")} sx={{cursor:"pointer",color:"#3B3F76"}}/>
            <UniversityDetailed data={props.data.university._id}/>
            </Box>
        }

    </div>
  )
}

export default MainPopup